

const { feWp } = window;
const { addAction } = feWp.hooks;

// Function to stop autoplay on the slider object
const stopAutoPlay = ( sliderObj ) => {
  sliderObj.autoplay.stop();
};

// Function to set animation duration on elements with class 'line-animator'
const setAnimationDuration = ( sliderObj, duration ) => {
  sliderObj.el.querySelectorAll( '.line-animator' )?.forEach( line => {
    line.style.animationDuration = `${duration}ms`;
  } );
};

/*
Function to set all .e-div--media-wrapper divs to the maximum height within 
each Swiper instance if screen width is below 992
*/
function setMaxHeightForSwiperItems( swiper, targetElement ) {
  if ( window.innerWidth >= 992 ) {
    swiper.slides.forEach( slide => {
      slide.querySelectorAll( targetElement ).forEach( item => {
        item.style.height = '100%';
      } );
    } );
    return;
  }

  const slides = swiper.slides;
  let heights = [];

  slides.forEach( slide => {
    const item = slide.querySelector( targetElement );

    if ( item ) {
      heights.push( item.clientHeight );
    }
  } );

  const maxHeight = Math.max( ...heights );

  slides.forEach( slide => {
    const item = slide.querySelector( targetElement );

    if ( item ) {
      item.style.height = `${maxHeight}px`;
    }
  } );
}

addAction(
  'b3rg_tab_slider_content_init',
  'b3rg/tab-slider',
  ( settings, swiperTabContent, contentSwiper ) => {
    if ( contentSwiper.el.closest( '.e-stn--logo-testimonial-slider .e-tbs__content' ) ) {

      setMaxHeightForSwiperItems( contentSwiper,'.e-div--media-wrapper' );
      const navSwiper = contentSwiper.thumbs.swiper;

      //set animation duration
      const animateDuration = settings.autoplay ? settings.autoplay?.delay + 500: 0;
      setAnimationDuration( navSwiper, animateDuration );

      // When user clicks the thumb slider, stop autoplay
      navSwiper.on( 'click', function ( ) {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );

      // When user touches and drags the content slider, stop autoplay
      contentSwiper.on( 'touchEnd', function ( ) {
        setAnimationDuration( navSwiper, 0 );
        stopAutoPlay( contentSwiper );
      } );

      //When user resize the window size
      contentSwiper.on( 'resize', function ( ) {
        setMaxHeightForSwiperItems( contentSwiper,'.e-div--media-wrapper' );
      } );
    }
  },
  10,
  1,
);
